export enum IWorkingDaysAnalyticsActivityEnum {
  StartTime = 'WorkingDaysAnalyticsActivity.starttime',
  LocalStartTime = 'WorkingDaysAnalyticsActivity.localstarttime',
  LocalStartDate = 'WorkingDaysAnalyticsActivity.localstartdate',
  TotalDuration = 'WorkingDaysAnalyticsActivity.totalDuration',
  count = 'WorkingDaysAnalyticsActivity.count',
  TotalCallDuration = 'WorkingDaysAnalyticsActivity.totalCallDuration',
  CallCount = 'WorkingDaysAnalyticsActivity.callCount',
  AppId = 'WorkingDaysAnalyticsActivity.appid',
  AverageDuration = 'WorkingDaysAnalyticsActivity.averageDuration',
  CumulativeAverageDuration = 'WorkingDaysAnalyticsActivity.cumulativeAverageDuration',
  UserId = 'WorkingDaysAnalyticsActivity.userid',
  CumulativeAverageDurationDifference = 'WorkingDaysAnalyticsActivity.cumulativeAverageDurationDifference',
  StartTimeDay = 'WorkingDaysAnalyticsActivity.starttime.day',
  DayCount = 'WorkingDaysAnalyticsActivity.dayCount',
  WeekCount = 'WorkingDaysAnalyticsActivity.weekCount',
  AverageDurationPerCount = 'WorkingDaysAnalyticsActivity.averageDurationPerCount',
}

export enum IWorkingDaysAnalyticsActivityV2Enum {
  StartTime = 'WorkingDaysAnalyticsActivityV2.starttime',
  LocalStartTime = 'WorkingDaysAnalyticsActivityV2.localstarttime',
  LocalStartDate = 'WorkingDaysAnalyticsActivityV2.localstartdate',
  TotalDuration = 'WorkingDaysAnalyticsActivityV2.totalDuration',
  TotalCallDuration = 'WorkingDaysAnalyticsActivityV2.totalCallDuration',
  CallCount = 'WorkingDaysAnalyticsActivityV2.callCount',
  count = 'WorkingDaysAnalyticsActivityV2.count',
  AppId = 'WorkingDaysAnalyticsActivityV2.appid',
  AverageDuration = 'WorkingDaysAnalyticsActivityV2.averageDuration',
  CumulativeAverageDuration = 'WorkingDaysAnalyticsActivityV2.cumulativeAverageDuration',
  UserId = 'WorkingDaysAnalyticsActivityV2.userid',
  CumulativeAverageDurationDifference = 'WorkingDaysAnalyticsActivityV2.cumulativeAverageDurationDifference',
  StartTimeDay = 'WorkingDaysAnalyticsActivityV2.starttime.day',
  DayCount = 'WorkingDaysAnalyticsActivityV2.dayCount',
  WeekCount = 'WorkingDaysAnalyticsActivityV2.weekCount',
  AverageDurationPerCount = 'WorkingDaysAnalyticsActivityV2.averageDurationPerCount',
  WeekdayIndex = 'WorkingDaysAnalyticsActivityV2.weekday_index',
  HeatmapSegment = 'WorkingDaysAnalyticsActivityV2.heatmapsegment',
}

export enum IWorkingDaysAnalyticsActivityMetricsEnum {
  TotalDuration = 'WorkingDaysAnalyticsActivity.totalDuration',
  count = 'WorkingDaysAnalyticsActivity.count',
}

export enum IWorkingDaysAnalyticsActivityV2MetricsEnum {
  TotalDuration = 'WorkingDaysAnalyticsActivityV2.totalDuration',
  count = 'WorkingDaysAnalyticsActivityV2.count',
  TotalCallDuration = 'WorkingDaysAnalyticsActivityV2.totalCallDuration',
  CallCount = 'WorkingDaysAnalyticsActivityV2.callCount',
}

export enum IAppValueMetrics {
  Duration = 'Duration',
  Interactions = 'Interactions',
}

export enum IGoalOperator {
  Max = 'Max',
  Min = 'Min',
}
